import { render, staticRenderFns } from "./LandingPageIndex.vue?vue&type=template&id=f5fa0872&scoped=true&"
import script from "./LandingPageIndex.vue?vue&type=script&lang=js&"
export * from "./LandingPageIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fa0872",
  null
  
)

export default component.exports